import PropTypes from "prop-types";
import React from "react";
import "./Button.css";

const Button = (props) => {
	const {
		action,
		size,
		full,
		hierarchy,
		children,
		onClick,
		disabled,
		style,
		type,
		className
	} = props;

	return (
		<button
			type={type}
			disabled={disabled}
			className={`btn btn-${action} btn-${size} btn-${hierarchy} ${full &&
				"btn__full"} ${disabled ? "btn__disabled" : ""} ${className}`}
			onClick={onClick || (() => false)}
			style={style}>
			{children}
		</button>
	);
};

Button.propTypes = {
	action: PropTypes.oneOf([
		"cta",
		"success",
		"destructive",
		"warning",
		"dark",
		"light",
		"link"
	]),
	type: PropTypes.oneOf(["button", "reset", "submit"]),
	disabled: PropTypes.bool,
	full: PropTypes.bool,
	hierarchy: PropTypes.oneOf(["primary", "secondary", "tertiary"]),
	size: PropTypes.oneOf(["lg", "md", "sm"])
};

Button.defaultProps = {
	action: "cta",
	full: false,
	hierarchy: "primary",
	size: "md",
	disabled: false,
	type: "button"
};

export default Button;
